export default __webpack_public_path__ + "static/media/Long Green.2ccfa11b.png";